import { supabase } from './supabase';
import type { Database } from './db.types';

export type Tables<T extends keyof Database['public']['Tables']> = Database['public']['Tables'][T]['Row'];
export type Inserts<T extends keyof Database['public']['Tables']> = Database['public']['Tables'][T]['Insert'];
export type Updates<T extends keyof Database['public']['Tables']> = Database['public']['Tables'][T]['Update'];

// Typed client
export const db = supabase;

// Type aliases for convenience
export type Profile = Tables<'profiles'>;
export type Record = Tables<'records'>;
export type Attachment = Tables<'attachments'>;
export type Event = Tables<'events'>;

export type RecordInsert = Inserts<'records'>;
export type RecordUpdate = Updates<'records'>;
export type EventInsert = Inserts<'events'>;